export default "__VITE_ASSET__Cc7uU5YD__"